import { combineReducers } from 'redux';
import allLessons from './lessonTitles';
import activeScene from './activeScene';
import activeLesson from './activeLesson';
import lessonData from './lessonData';
import lessonHistory from './lessonHistory';
import checkpointData from './checkpointData';
import sourceDecisionData from './sourceDecisionData';
import userDecisionData from './userDecisionData';
import interpersonalDecisionData from './interpersonalDecisionData';
import policyDecisionData from './policyDecisionData';
import prototypes from './prototypes';
import decisionState from './decisionState';
import decisionIndex from './decisionIndex';
const rootReducer = combineReducers({
    allLessons,
    activeScene,
    activeLesson,
    lessonData,
    lessonHistory,
    checkpointData,
    sourceDecisionData,
    userDecisionData,
    interpersonalDecisionData,
    policyDecisionData,
    prototypes,
    decisionState,
    decisionIndex
})

export default rootReducer;